var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.05 11.9v11.5h-2V11.9h2zm7 0v11.5h-2V11.9h2zm-2.825-4.6c.317 0 .575.258.575.575V9.6h-4.6V7.875c0-.317.258-.575.575-.575h3.45zm6.325 2.3H20.1V7.875A2.879 2.879 0 0 0 17.225 5h-3.45A2.879 2.879 0 0 0 10.9 7.875V9.6H7.45A3.454 3.454 0 0 0 4 13.05v9.2a3.454 3.454 0 0 0 3.45 3.45h16.1A3.454 3.454 0 0 0 27 22.25v-9.2a3.454 3.454 0 0 0-3.45-3.45z",
    fill: "#ED1C24",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon04);
export default __webpack_public_path__ + "static/media/icon-04.28304a0f76fbbbe14ce3bb37585955fd.svg";
export { ForwardRef as ReactComponent };